import React from 'react';
import { FormattedMarkdown } from '@qover/react-intl';

export default {
  title: <FormattedMarkdown id="confirmation.title" />,
};
